export default __webpack_public_path__ + "static/media/login.6bb53ed9.jpg";